/** Sequence Annotation System — Core Types
 *
 * Provides structured annotation support for macromolecule columns:
 * - Column-level annotations (regions, liabilities) stored as column tags
 * - Row-level annotation hits stored in a hidden companion column
 */
/** Visual mark type */
export var AnnotationVisualType;
(function (AnnotationVisualType) {
    AnnotationVisualType["Region"] = "region";
    AnnotationVisualType["Point"] = "point";
    AnnotationVisualType["Motif"] = "motif";
})(AnnotationVisualType || (AnnotationVisualType = {}));
/** Grouping category */
export var AnnotationCategory;
(function (AnnotationCategory) {
    AnnotationCategory["Structure"] = "structure";
    AnnotationCategory["Liability"] = "liability";
    AnnotationCategory["PTM"] = "ptm";
    AnnotationCategory["Custom"] = "custom";
})(AnnotationCategory || (AnnotationCategory = {}));
/** Severity for liabilities */
export var LiabilitySeverity;
(function (LiabilitySeverity) {
    LiabilitySeverity["High"] = "high";
    LiabilitySeverity["Medium"] = "medium";
    LiabilitySeverity["Low"] = "low";
    LiabilitySeverity["Info"] = "info";
})(LiabilitySeverity || (LiabilitySeverity = {}));
/** Default colors for annotation categories */
export const ANNOTATION_COLORS = {
    structure: {
        FR: ['#0095ff', '#289dfd', '#48adff', '#3ba5fc'],
        CDR: ['#ffdca3', '#facb83', '#f7a224'],
    },
    liability: {
        deamidation: '#E53935',
        isomerization: '#FF9800',
        oxidation: '#9C27B0',
        glycosylation: '#4CAF50',
        freeCysteine: '#607D8B',
    },
};
/** Background opacity for region overlays in the cell renderer */
export const REGION_BG_OPACITY = 0.25;
/** Underline height in pixels for liability markers */
export const LIABILITY_UNDERLINE_HEIGHT = 3;
//# sourceMappingURL=annotations.js.map